/**
 * This page is used to confirm that we've authorised an account.
 */
import { useLocation } from 'react-router-dom'
import pluralize from 'pluralize'
import { AccountOnboardingLayout } from '../../containers/AccountOnboardingLayout'
import AccountSummary from '../../components/account/AccountSummary'
import SimpleLink from '../../components/links/SimpleLink'
import { AuthorisedAccountView } from '../../api/client'

type LocationState = {
    authorisedAccounts?: Array<AuthorisedAccountView>
}

function NewAccountAuthorisedPage() {
    const location = useLocation()
    const state = location.state as LocationState

    // SOMEDAY: get the new and updated accounts details from the query params
    // and display them here.
    return (
        <AccountOnboardingLayout title="Success!">
            {state?.authorisedAccounts ? (
                <>
                    <p>
                        Your {pluralize('account', state.authorisedAccounts.length)}{' '}
                        {pluralize('has', state.authorisedAccounts.length)}
                        been added to Arwen.
                    </p>
                    <ul className="list-none">
                        {state.authorisedAccounts.map((account) => (
                            <li key={account.id}>
                                <AccountSummary {...account} />
                            </li>
                        ))}
                    </ul>{' '}
                </>
            ) : (
                <p className="mb-4">Your account has been added to Arwen.</p>
            )}
            <p className="mb-4">
                We'll be in touch via email as soon as Arwen is live with your chosen settings.
            </p>
            <SimpleLink to="/account/new">Add another profile</SimpleLink>
        </AccountOnboardingLayout>
    )
}

export default NewAccountAuthorisedPage
